import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import Breadcrumb from '../common/breadcrumb';
import VerWhatsappCampaignsDatatable from '../common/ver-whatsapp-campaigns-datatable';
import AuthService from "../services/auth.service";
import ApiService from "../services/api.service";
import { ToastContainer, toast } from 'react-toastify';
import Swal from 'sweetalert2';

export class Ver_whatsapp_campaigns extends Component {

    constructor(props) {
        super(props);
        this.handler = this.handler.bind(this);
        this.onChangeFilter = this.onChangeFilter.bind(this);
        this.deleteCampaign = this.deleteCampaign.bind(this);
        this.handlerPromotions = this.handlerPromotions.bind(this);
        this.state = {
            results: [],
            filter: '',
            temp: [],
        };
    }

    handler(data_row) {
        this.props.history.push("/edit-whatsapp-campaign/"+data_row.original.id);
        window.location.reload();
    }

    handlerPromotions(data_row) {
        this.props.history.push("/campaign-promotions/"+data_row.original.id);
        window.location.reload();
    }

    deleteCampaign(data_row) {
       Swal.fire({
        title: 'Confirmar',
        text: '¿Desea eliminar la campaña '+ data_row.original.Nombre + '?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Confirmar',
        cancelButtonText: 'Cancelar'
     }).then((result) => {
        if(result.value){
            var user = AuthService.getCurrentUser();
            ApiService.deleteWhatsappCampaign(user.token,data_row.original.id).then(
                (res) => {
                    toast.success("Campaña eliminada!");
                    this.getDataCampaigns();
                },
                error => {
                const resMessage =
                    (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                    error.message ||
                    error.toString();
                    toast.error(resMessage);
                }
            )
       }
     })
    }

    onChangeFilter(e) {
        this.setState({
            filter: e.target.value
        }, function () {
        });

        const val = e.target.value.toLowerCase();
        if (this.state.temp.length != 0) {
          var columns = Object.keys(this.state.temp[0]);
          columns.splice(columns.length);

          if (!columns.length)
            return;
          const rows = this.state.temp.filter(function (d) {
            for (let i = 0; i <= columns.length; i++) {
              let column = columns[i];
              if (d[column] && d[column].toString().toLowerCase().indexOf(val) > -1) {
                return true;
              }
            }
          });

          this.setState({
            results: rows
        }, function () {
            this.renderResults(this.state.results.length);
        });
        }

        e.preventDefault();
      }

    componentWillMount() {
        this.getDataCampaigns();
    }

    getDataCampaigns(){
        var user = AuthService.getCurrentUser();
        ApiService.getWhatsappCampaigns(user.token).then(
            (res) => {
                if(res && res.status == 'success'){
                    const items = res.data.map(function(row) {
                        const statusText = {
                            'DRAFT': 'BORRADOR',
                            'BORRADOR': 'BORRADOR',
                            'PROGRAMADA': 'PROGRAMADA',
                            'ENVIADA': 'ENVIADA',
                            'CANCELADA': 'CANCELADA',
                        };

                        return {
                            id: row.id,
                            Nombre: row.campaign_name,
                            Grupo: row.Cluster ? row.Cluster.cluster_name : 'Sin grupo',
                            Estado: statusText[row.campaign_status] || row.campaign_status,
                            'Fecha Programada': row.scheduled_date ? new Date(row.scheduled_date).toLocaleDateString('es-ES') : 'No programada',
                            Enviados: row.sent_count || 0,
                            data: row
                        }
                     })
                this.setState({ results:items });
                this.setState({ temp:items });
                this.renderResults(this.state.results.length);
                }
            },
            error => {
              const resMessage =
                (error.response &&
                  error.response.data &&
                  error.response.data.message) ||
                error.message ||
                error.toString();
            }
          );
    }

    renderResults(length){
		return this.state.results.length === 0
			? 'No hay datos.'
			: <VerWhatsappCampaignsDatatable
            multiSelectOption={false}
            myData={this.state.results}
            pageSize={length<=10?length:10}
            pagination={true}
            class="-striped -highlight"
            handler = {this.handler}
            deleteCampaign = {this.deleteCampaign}
            handlerPromotions = {this.handlerPromotions}
        />
    }

    render() {
        return (
            <Fragment>
                <Breadcrumb title="Campañas de WhatsApp" parent="Promociones" />
                <div className="container-fluid">
                    <div className="card">
                        <div className="card-header">
                            <h5>Gestión de Campañas de WhatsApp</h5>
                        </div>
                        <div className="card-body">
                            <div className="btn-popup pull-right">
                                <Link to="/create-whatsapp-campaign" className="btn btn-secondary">Crear Campaña</Link>
                            </div>
                            <div className="clearfix"></div>
                            <div id="batchDelete" className="category-table user-list order-table coupon-list-delete">
                            <div className="col-md-6 table-filter">
                            <input
                                placeholder="Escriba para filtrar todas las columnas"
                                name="filter"
                                type="text"
                                className="form-control"
                                autoComplete="off"
                                onInput={this.onChangeFilter}
                            />
                            </div>
                                {this.renderResults()}
                            </div>
                        </div>
                    </div>
                </div>
                <ToastContainer />
            </Fragment>
        )
    }
}

export default Ver_whatsapp_campaigns
